// Port of api/fuel/app/classes/filter/search/games/filters/query/other/languages.php
import DB from 'offline/db'
import Util from 'offline/util'
export default {
	name: 'other.languages',
	priority: 76,
	require: function(config, filter) { return filter.languages && filter.languages.length > 0 },
	run: function(config, filter, data, query) {
		var include = [], exclude = []
		for (var i = 0; i < filter.languages.length; i++) {
			var l = filter.languages[i]
			if (l < 0) exclude.push(-l)
			else include.push(l)
		}
		if (include.length) {
			var games = DB.query('SELECT DISTINCT game_id AS g FROM game_language WHERE language_id IN(' + Util.in(include) + ')')
			var ids = Util.pluck(games, 'g')
			if (ids.length) query.where('g.game_id', 'in', ids)
			else query.where('g.game_id', '=', 0)
		}
		if (exclude.length) {
			var exGames = DB.query('SELECT DISTINCT game_id AS g FROM game_language WHERE language_id IN(' + Util.in(exclude) + ')')
			var exIds = Util.pluck(exGames, 'g')
			if (exIds.length) query.where('g.game_id', 'not in', exIds)
		}
	}
}
